import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chip = _resolveComponent("Chip")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_Chip, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.ChipTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.ChipTypeConst.STYLE)),
        class: _normalizeClass({ [_ctx.getPropertyValue(_ctx.ChipTypeConst.CLASS) ?? '']: true, 'customrequired': _ctx.getPropertyBooleanValue(_ctx.ChipTypeConst.REQUIRED),'p-readonly': _ctx.getPropertyBooleanValue(_ctx.ChipTypeConst.READONLY) }),
        name: _ctx.getPropertyValue(_ctx.ChipTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.ChipTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.ChipTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.ChipTypeConst.PLACEHOLDER),
        separator: _ctx.getPropertyValue(_ctx.ChipTypeConst.SEPARATOR),
        addOnBlur: _ctx.getPropertyBooleanValue(_ctx.ChipTypeConst.ADDONBLUR),
        allowDuplicate: _ctx.getPropertyBooleanValue(_ctx.ChipTypeConst.ALLOWDUPLICATE),
        max: _ctx.getPropertyNumberValue(_ctx.ChipTypeConst.MAX),
        inputId: _ctx.getPropertyValue(_ctx.ChipTypeConst.INPUTID),
        readonly: _ctx.getPropertyBooleanValue(_ctx.ChipTypeConst.READONLY),
        modelValue: _ctx.vmodel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vmodel) = $event))
      }, null, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "separator", "addOnBlur", "allowDuplicate", "max", "inputId", "readonly", "modelValue"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.ChipTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}